import Vue from "vue";
import fileDownload from "js-file-download";

// Assign js-file-download to Vue's prototype
Vue.prototype.$fileDownload = fileDownload;
